export type AppRoute =
  | { kind: 'login' }
  | { kind: 'agencies' }
  | { kind: 'agencyDetail'; agencyId: string }

const NAV_EVENT = 'app:navigate'
const AGENCY_DETAIL_PATTERN = /^\/agencies\/([^/]+)\/?$/

export function parseAppRoute(pathname: string): AppRoute {
  if (pathname === '/login') {
    return { kind: 'login' }
  }

  const detailMatch = AGENCY_DETAIL_PATTERN.exec(pathname)
  if (detailMatch?.[1]) {
    return { kind: 'agencyDetail', agencyId: decodeURIComponent(detailMatch[1]) }
  }

  return { kind: 'agencies' }
}

export function getAppRoute(): AppRoute {
  return parseAppRoute(window.location.pathname)
}

export function toPath(route: AppRoute): string {
  switch (route.kind) {
    case 'login':
      return '/login'
    case 'agencyDetail':
      return `/agencies/${encodeURIComponent(route.agencyId)}`
    case 'agencies':
      return '/agencies'
  }
}

export function navigateTo(route: AppRoute) {
  window.history.pushState(null, '', toPath(route))
  window.dispatchEvent(new Event(NAV_EVENT))
}

export function subscribeToNavigation(onStoreChange: () => void) {
  const handler = () => onStoreChange()
  window.addEventListener('popstate', handler)
  window.addEventListener(NAV_EVENT, handler)
  return () => {
    window.removeEventListener('popstate', handler)
    window.removeEventListener(NAV_EVENT, handler)
  }
}

export function isAgenciesSection(route: AppRoute): boolean {
  return route.kind === 'agencies' || route.kind === 'agencyDetail'
}
